module.exports = __webpack_public_path__ + "1237ab3d0b70956309b958edc504fe6d.svg";